import React from 'react';

// nodejs library to set properties for components
import PropTypes from "prop-types";

import OthelloModalBase from './OthelloModalBase.jsx';

export default function OthelloMensaje({ ...props }) {
    const {
        tituloliteral,
        descrip,
        open,
        modo,
        onCloseResulModal,
        botones,
        textobotones
    } = props;

    return (
        <OthelloModalBase tituloliteral={tituloliteral} modo={modo} open={open} onCloseResulModal={onCloseResulModal} botones={botones} textobotones={textobotones}>
            <h6>{descrip}</h6>
        </OthelloModalBase>
    );
}

OthelloMensaje.propTypes = {

    tituloliteral: PropTypes.string,
    descrip: PropTypes.string,
    open: PropTypes.bool, //Se gestioana con DataStateModal
    modo: PropTypes.object, //Constante ModoModal
    onCloseResulModal: PropTypes.object,
    botones: PropTypes.bool,  //Los botones se gestionan con MessageOthelloBoxButtons
    textobotones: PropTypes.object, //Array de literales 
};

